import { useParams } from 'crossroad';
import { PassageContextAnimator } from './passage-context-animator';
import { PanelSettledProvider } from '@/context/PanelSettledContext';

export default function PassagePage() {
    const passageIdFromPassageUrl = useParams('/app/passage/:id')?.id;
    const passageIdFromContextUrl = useParams('/app/passage/:id/context/:contextCategory')?.id;
    const passageId = passageIdFromPassageUrl || passageIdFromContextUrl || null;

    return (
        <PanelSettledProvider>
            <PassageContextAnimator passageId={passageId} />
        </PanelSettledProvider>
    );
}
